const totals = {
  'totals.credits': 'Créditos',
  'totals.current_balance': 'Saldo atual',
  'totals.previous_balance': 'Saldo anterior',
  'totals.exchange_rate': 'Taxa de conversão',
  'totals.debits': 'Despesas',
  'totals.international_debits': 'Despesas internacionais',
  'totals.partial.invoice': 'Total de despesas (parcial)',
  'totals.amountPaid': 'Valor Pago: {value}',
};

export default totals;
